// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KBgN","left":"styles_left__3J9Gs"};